import React from 'react';
import {
  FormControlLabel, Checkbox, makeStyles,
} from '@material-ui/core';
import { withTranslation } from 'config/i18n';
import OutlinedCheckbox from 'components/shared/icons/OutlinedCheckbox';

const useStyles = makeStyles((theme) => ({
  checkboxWrapper: {
    // paddingTop: theme.spacing(2),
    height: '100%',
    [theme.breakpoints.only('md')]: {
      top: theme.spacing(0),
    },
    [theme.breakpoints.only('sm')]: {
      position: 'relative',
      marginTop: theme.spacing(-2),
    },
  },
  checkboxLabel: {
    fontSize: theme.typography.pxToRem(12),
  },
}));

const SameLocationCheckBox = ({
  t, checked, onChange, disabled,
}) => {
  const classes = useStyles();

  return (
    <>
      <FormControlLabel
        className={classes.checkboxWrapper}
        classes={{
          label: classes.checkboxLabel,
        }}
        control={(
          <Checkbox
            checked={checked}
            onChange={() => onChange(!checked)}
            name="SameLocation"
            color="primary"
            checkedIcon={<OutlinedCheckbox />}
            disabled={disabled}
          />
                    )}
        label={t('fe_es_geo_widget:place.return_to_same')}
      />
    </>
  );
};
export default withTranslation(['fe_es_geo_widget'])(SameLocationCheckBox);
